export const experienceData = [
    {
        id: 1,
        company: 'PEER Group Inc',
        jobtitle: 'Full Stack Software Developer',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        company: 'SubServe (Venture Lab)',
        jobtitle: 'Developer & Coordinator',
        startYear: '2020',
        endYear: '2020'
    },
    {
        id: 3,
        company: 'Kiban Tech, co., Ltd',
        jobtitle: 'Business Administrator',
        startYear: '2015',
        endYear: '2019'
    },
]